import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1054.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M2122 7348 c-17 -17 -15 -42 8 -70 10 -14 16 -28 13 -32 -3 -3 -61
-6 -128 -6 -81 0 -125 -4 -133 -12 -18 -18 -14 -56 7 -68 12 -6 95 -10 200
-10 150 0 182 3 195 16 31 30 19 58 -53 127 -70 68 -87 77 -109 55z"/>
<path d="M1876 7084 c-13 -35 -3 -53 68 -122 41 -40 76 -72 79 -72 13 0 37 33
37 50 0 10 -12 32 -26 49 l-25 30 137 3 c118 3 138 5 148 21 8 12 8 22 0 35
-10 15 -33 17 -211 20 -176 2 -201 0 -207 -14z"/>
<path d="M8790 6296 c-118 -39 -191 -107 -221 -208 -25 -81 -22 -136 10 -211
40 -93 118 -141 340 -211 113 -36 141 -56 141 -106 0 -48 -30 -75 -93 -84 -90
-14 -187 27 -228 94 -28 45 -37 43 -177 -41 -20 -12 -28 -25 -30 -53 -3 -36 2
-43 60 -101 92 -90 184 -125 330 -125 176 0 306 76 359 210 23 58 16 166 -14
225 -46 90 -100 127 -276 185 -169 56 -201 77 -201 135 0 45 29 67 95 73 70 6
106 -9 155 -65 l39 -44 88 51 c48 29 90 54 92 56 10 10 -26 68 -69 110 -56 55
-126 96 -192 112 -58 15 -161 14 -208 -2z"/>
<path d="M3095 6278 c-3 -7 -4 -236 -3 -508 l3 -495 115 0 115 0 5 280 5 280
23 -25 c13 -14 36 -47 51 -75 58 -104 162 -271 181 -290 26 -26 24 -29 156
190 59 99 114 186 121 193 16 16 15 37 14 -283 -1 -137 2 -256 7 -263 6 -9 37
-12 118 -10 l109 3 0 505 0 505 -116 3 -116 3 -31 -51 c-18 -28 -32 -54 -32
-56 0 -3 -13 -25 -30 -49 -16 -24 -30 -46 -30 -48 0 -6 -125 -204 -141 -223
-16 -20 -29 -7 -80 79 -23 40 -52 88 -64 107 -36 57 -78 125 -114 184 l-34 56
-114 0 c-82 0 -115 -4 -118 -12z"/>
<path d="M4300 5780 l0 -511 113 3 112 3 0 505 0 505 -112 3 -113 3 0 -511z"/>
<path d="M4637 6283 c-12 -12 -8 -198 5 -211 8 -8 51 -12 129 -12 97 0 118 -3
123 -16 3 -9 6 -181 6 -382 -1 -202 -1 -373 0 -380 0 -10 26 -12 113 -10 l112
3 2 384 c2 212 6 388 10 392 5 5 62 10 128 11 l120 3 0 110 0 110 -371 3
c-204 1 -373 -1 -377 -5z"/>
<path d="M5679 6263 c-6 -16 -31 -86 -55 -158 -23 -71 -95 -283 -159 -470 -63
-187 -113 -346 -110 -353 3 -9 33 -12 121 -10 l116 3 25 70 c14 39 31 73 37
77 6 4 88 8 181 8 94 0 175 -4 181 -8 7 -4 23 -38 36 -77 l24 -70 122 -3 c88
-2 122 1 122 9 0 15 -57 197 -70 224 -5 11 -30 83 -55 160 -25 77 -50 149 -55
160 -5 11 -16 43 -24 70 -23 78 -105 316 -123 358 l-16 37 -144 0 -143 0 -11
-27z m171 -277 c0 -13 16 -64 76 -250 21 -64 23 -80 12 -87 -15 -10 -178 -12
-202 -3 -20 8 -20 24 -1 66 8 18 28 80 45 138 17 58 35 115 40 128 10 24 30
30 30 8z"/>
<path d="M6425 6278 c-3 -7 -4 -236 -3 -508 l3 -495 239 -3 c212 -2 247 0 308
17 158 45 279 171 337 350 6 19 11 83 11 142 0 92 -4 119 -25 176 -34 89 -76
153 -138 209 -59 53 -96 73 -189 103 -61 19 -90 21 -303 21 -179 0 -237 -3
-240 -12z m508 -232 c100 -36 167 -140 167 -261 0 -87 -14 -131 -59 -192 -58
-76 -110 -97 -255 -101 -91 -3 -121 -1 -127 10 -10 15 -12 518 -3 542 5 13 25
16 123 16 70 -1 131 -6 154 -14z"/>
<path d="M1337 6264 c-12 -12 -8 -973 3 -995 9 -17 22 -19 103 -19 51 0 98 4
105 8 10 7 12 115 10 508 l-3 499 -106 3 c-58 1 -108 -1 -112 -4z"/>
<path d="M1747 6263 c-4 -3 -7 -230 -7 -504 0 -444 2 -498 16 -503 9 -3 138
-6 288 -6 198 0 275 3 284 12 16 16 16 190 0 206 -8 8 -62 12 -179 12 -147 0
-168 2 -173 17 -4 9 -6 181 -6 382 0 201 1 372 0 379 0 9 -29 12 -108 12 -60
0 -112 -3 -115 -7z"/>
<path d="M7775 6251 c-90 -25 -208 -101 -261 -167 -80 -101 -114 -200 -114
-334 0 -107 20 -186 67 -264 104 -172 322 -278 500 -243 l58 12 3 93 c2 56 -1
92 -7 92 -6 0 -22 -17 -37 -37 -38 -51 -53 -63 -85 -63 -45 0 -100 72 -122
163 l-7 27 119 0 c132 0 145 5 139 62 l-3 33 -129 3 c-75 1 -135 7 -143 14 -9
7 -13 37 -13 97 0 141 -12 131 160 131 168 0 160 4 160 -87 l0 -55 37 7 c21 4
41 9 45 11 5 3 8 32 8 65 l0 59 69 0 c43 0 73 -5 77 -12 4 -6 10 -56 13 -109
5 -82 9 -101 26 -113 29 -22 44 -19 56 11 14 36 13 166 -1 228 -33 150 -152
289 -305 356 -40 17 -73 22 -165 25 -63 2 -128 -1 -145 -5z m176 -112 c22 -22
79 -135 79 -156 0 -10 -33 -13 -131 -13 l-131 0 6 24 c33 132 119 203 177 145z
m-252 -46 c0 -10 -8 -40 -18 -68 l-18 -50 -51 -3 c-37 -2 -52 1 -52 9 0 15
115 129 130 129 5 0 10 -8 9 -17z m481 -42 c33 -32 60 -64 60 -70 0 -7 -21
-11 -53 -11 l-53 0 -21 70 c-26 89 -15 91 67 11z m-536 -294 c-1 -60 -6 -113
-11 -118 -6 -6 -36 -9 -69 -7 l-58 3 -9 40 c-9 43 -4 165 7 184 5 8 31 11 74
9 l66 -3 0 -108z m36 -277 c8 -25 19 -51 24 -58 5 -8 4 -18 -2 -24 -17 -17
-142 94 -142 127 0 3 24 5 53 3 l52 -3 15 -45z"/>
<path d="M7557 5819 c-13 -8 -17 -23 -17 -62 0 -60 10 -80 36 -75 16 3 20 14
22 64 3 67 -10 90 -41 73z"/>
<path d="M8432 5950 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M8445 5785 c2 -76 6 -140 9 -143 6 -5 11 77 7 107 -2 7 3 10 9 6 8
-5 9 13 4 62 -10 97 -10 97 -21 100 -8 3 -10 -40 -8 -132z"/>
<path d="M8238 5749 c-5 -29 3 -45 16 -32 9 9 7 51 -3 57 -5 3 -11 -8 -13 -25z"/>
<path d="M8119 5654 c-11 -13 -15 -58 -17 -193 -2 -97 1 -194 5 -216 8 -34 13
-40 37 -43 22 -3 36 6 72 44 38 42 44 46 50 28 4 -10 10 -21 13 -24 4 -3 20
-32 36 -65 28 -56 32 -60 64 -60 58 0 60 21 12 120 -25 51 -39 91 -34 96 5 5
30 13 57 18 58 11 81 30 72 63 -6 25 -293 238 -331 246 -12 2 -27 -4 -36 -14z"/>
<path d="M7867 5483 c-13 -13 -7 -40 14 -59 21 -19 21 -18 40 5 26 31 24 37
-12 50 -38 13 -34 13 -42 4z"/>
<path d="M6342 4559 l3 -384 174 -3 c286 -4 419 31 513 137 68 77 82 119 82
251 0 102 -3 121 -24 165 -27 56 -100 134 -147 158 -88 46 -111 49 -361 54
l-242 5 2 -383z m458 175 c68 -37 94 -88 94 -179 -1 -56 -5 -77 -24 -106 -46
-70 -126 -102 -240 -97 l-65 3 -3 190 c-1 104 0 195 2 202 4 9 32 13 97 13 79
0 98 -3 139 -26z"/>
<path d="M7397 4903 c-8 -21 -26 -63 -40 -93 -37 -83 -58 -131 -132 -300 -37
-85 -85 -193 -107 -239 -22 -49 -35 -88 -30 -93 5 -5 56 -7 113 -6 l104 3 29
73 30 72 158 0 158 0 11 -27 c6 -15 16 -41 24 -58 7 -16 15 -38 19 -47 5 -16
19 -18 108 -18 57 0 108 4 114 8 11 6 -31 111 -129 325 -15 32 -27 60 -27 62
0 2 -15 37 -34 77 -18 40 -40 89 -49 108 -8 19 -27 62 -41 95 -14 33 -30 67
-35 75 -6 12 -33 16 -118 18 l-111 3 -15 -38z m182 -325 c36 -82 33 -88 -53
-88 -41 0 -77 4 -80 9 -5 8 26 93 62 170 l15 33 18 -38 c9 -22 26 -60 38 -86z"/>
<path d="M7867 4933 c-10 -9 -8 -145 1 -160 5 -8 45 -13 117 -15 l110 -3 5
-290 5 -290 105 0 105 0 3 292 2 292 113 3 112 3 3 88 3 87 -339 0 c-186 0
-342 -3 -345 -7z"/>
<path d="M8783 4928 c-5 -7 -33 -67 -63 -133 -29 -66 -64 -145 -78 -175 -13
-30 -33 -75 -44 -100 -11 -25 -26 -61 -35 -80 -8 -19 -19 -44 -24 -55 -5 -11
-26 -60 -48 -110 -31 -72 -36 -92 -25 -98 7 -4 57 -6 111 -5 l98 3 29 73 30
72 160 -2 160 -3 25 -65 c14 -36 30 -68 36 -72 13 -10 197 -10 212 0 10 6 -52
161 -157 387 -9 20 -84 190 -121 274 -45 102 -35 96 -152 99 -76 2 -107 -1
-114 -10z m156 -331 c44 -109 45 -107 -43 -107 -41 0 -77 4 -80 9 -6 9 41 139
55 156 5 5 9 18 9 29 0 36 26 -2 59 -87z"/>
</g>
</svg>





    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
